// libs
import { useState, useCallback, useEffect } from 'react';
import { getCouponV2 } from 'shared/api/cart';

import get from 'lodash/get';

import { COUPON_TYPE, CouponDetails, OfferDetails } from 'shared/layouts/Coupons/types';

// constants
import { EMPTY_COUPON_DATA } from 'shared/layouts/Coupons/constants';

// eslint-disable-next-line  no-undef
function useFetchCouponDetails(showDetailCoupon: ProductOffers.ShowDetailCoupon) {
  const couponId = get(showDetailCoupon.coupon, 'couponDetails.couponId', '');
  const [currentCouponDetails, setCurrentCouponDetails] = useState<CouponDetails>({});
  const [currentOfferDetails, setCurrentOfferDetails] = useState<OfferDetails>({});
  const fetchCouponDetailsData = useCallback(() => {
    if (showDetailCoupon.type === COUPON_TYPE.COUPON) {
      getCouponV2(couponId)
        .then((data) => {
          setCurrentCouponDetails({
            ...data,
            discount: get(showDetailCoupon.coupon, 'couponDetails.discount'),
            expiryEpoch: get(showDetailCoupon.coupon, 'expiryEpoch'),
            disabled: showDetailCoupon.disabled,
            couponDetails: get(showDetailCoupon.coupon, 'couponDetails'),
            deltaTextModified: get(showDetailCoupon.coupon, 'deltaTextModified'),
            deltaAmount: get(showDetailCoupon.coupon, 'deltaAmount'),
            deltaQuantity: get(showDetailCoupon.coupon, 'deltaQuantity'),
            offerId: get(showDetailCoupon.coupon, 'offerId'),
            offerType: get(showDetailCoupon.coupon, 'offerType'),
          });
        })
        .catch(() => {
          setCurrentCouponDetails({
            ...EMPTY_COUPON_DATA,
            couponCode: '',
            discount: 0,
            disabled: showDetailCoupon.disabled,
            deltaTextModified: get(showDetailCoupon.coupon, 'deltaTextModified'),
          });
        });
    } else if (showDetailCoupon.type === COUPON_TYPE.OFFER) {
      const {
        offerId,
        title,
        description,
        label,
        offerDiscount,
        expiryEpoch,
        deltaAmount,
        deltaQuantity,
        deltaTextModified,
        status,
        offerType,
        fundingType = 'na',
      } = showDetailCoupon.coupon;

      setCurrentOfferDetails({
        offerId,
        title,
        description,
        label,
        offerDiscount,
        expiryEpoch,
        deltaAmount,
        deltaQuantity,
        status,
        deltaTextModified,
        offerType,
        fundingType,
      });
    }
  }, [couponId, showDetailCoupon]);

  useEffect(() => fetchCouponDetailsData(), [fetchCouponDetailsData, showDetailCoupon]);
  return {
    currentCouponDetails,
    currentOfferDetails,
  };
}

export default useFetchCouponDetails;
